import {
  CAN_LEAVE,
  CLOSE_DIALOGUE,
  LEAVE_DIALOGUE,
  OPEN_DIALOGUE,
  START_SAVE,
} from './constants';

export function openDialogue(args) {
  return {
    type: OPEN_DIALOGUE,
    payload: args,
  };
}

export function closeDialogue() {
  return {
    type: CLOSE_DIALOGUE,
  };
}

export function leaveDialogue() {
  return {
    type: LEAVE_DIALOGUE,
  };
}

export function allowLeave() {
  return {
    type: CAN_LEAVE,
  };
}

export function startSave() {
  return {
    type: START_SAVE,
  };
}
